import PropTypes from 'prop-types'
import * as THREE from 'three'
import Base from './Base'

// https://github.com/mrdoob/three.js/blob/master/src/core/Object3D.js
export default class Object3D extends Base {
    static contextTypes = {
        parent: PropTypes.object,
    }

    static childContextTypes = {
        parent: PropTypes.object,
    }

    getChildContext() {
        return {
            parent: this.obj,
        }
    }

    static propTypes = {
        ...Base.propTypes,
        position: PropTypes.object,
        rotation: PropTypes.object,
        scale: PropTypes.object,
    }

    constructor(...args) {
        super(...args)
        this.obj = new THREE.Object3D() // placeholder

        // Component name as default Object name
        // friendly to threejs-inspector
        this.obj.name = this.constructor.name
    }

    componentDidMount() {
        this.update()
        if (this.context.parent) this.context.parent.add(this.obj)

        const { onMount } = this.props
        onMount && onMount(this.obj)
    }

    componentDidUpdate() {
        this.update()
    }

    componentWillUnmount() {
        if (this.context.parent) this.context.parent.remove(this.obj)

        const { onWillUnmount } = this.props
        onWillUnmount && onWillUnmount(this.obj)
    }

    // updating position & rotation
    update() {
        const { position, rotation, scale } = this.props
        if (position) this.obj.position.set(position.x, position.y, position.z)
        if (scale) this.obj.scale.set(scale.x, scale.y, scale.z)
        if (rotation) this.obj.rotation.set(rotation)
    }
}
